import React from 'react';

const Contact = () => {
    return (
        <div className=' py-14' id='contact'>
            <h2 className='text-4xl font-bold text-center py-12'>Contact Me</h2>
            <div className='flex justify-center items-center'>
                <div className="card bg-base-100 shadow-xl">
                    <div className="card-body w-80">
                        <form action="https://formspree.io/f/mknyebzg" method="POST" id='my-form'>
                            <div className="form-control w-full max-w-xs">
                                <label className="label">
                                    <span className="label-text">Name</span>
                                </label>
                                <input type="name"
                                    name='name'
                                    placeholder="Your Name"
                                    className="input input-bordered w-full max-w-xs"
                                />
                            </div>

                            <div className="form-control w-full max-w-xs">
                                <label className="label">
                                    <span className="label-text">Email</span>
                                </label>
                                <input type="email"
                                    name='email'
                                    placeholder="Your Email"
                                    className="input input-bordered w-full max-w-xs"
                                />
                            </div>

                            <div className="form-control w-full max-w-xs">
                                <label className="label">
                                    <span className="label-text">Phone</span>
                                </label>
                                <input type="text"
                                    name='phone'
                                    placeholder="Your Phone Number"
                                    className="input input-bordered w-full max-w-xs"
                                />
                            </div>
                            <div className="form-control w-full max-w-xs">
                                <label className="label">
                                    <span className="label-text">Message</span>
                                </label>
                                <input type="text"
                                    name='message'
                                    placeholder="Enter Message"
                                    className="textarea textarea-bordered w-full max-w-xs"
                                />
                            </div>

                            <input className="btn text-white w-full max-w-xs uppercase mt-3" type="submit" value='Submit' />
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contact;